import { ClaudeChatMock } from 'components/shared/bumperMcp/ClaudeMocks';
import { McpClientIcon } from 'components/shared/bumperMcp/McpClientIcon';
import { PromoCtaLink } from 'components/shared/bumperMcp/styled';
import { MCP_ROUTE } from 'routes/Mcp/constants';

import {
  BannerHeader,
  BannerIntro,
  BannerMock,
  BannerRoot,
  BannerText,
  BannerTitle,
  LogoCircle,
} from './styledComponents';

export const BumperMcpReportBanner = () => (
  <BannerRoot data-testid="bumper-mcp-report-banner">
    <BannerHeader>
      <BannerIntro>
        <LogoCircle>
          <McpClientIcon client="claude" size={34} />
        </LogoCircle>
        <div>
          <BannerTitle>Run Bumper reports right from Claude</BannerTitle>
          <BannerText>
            Connect once, then just ask Claude to pull VIN lookups, accident
            history, or market value.
          </BannerText>
        </div>
      </BannerIntro>
      <PromoCtaLink to={MCP_ROUTE} data-testid="bumper-mcp-report-banner-cta">
        Try it now
      </PromoCtaLink>
    </BannerHeader>
    <BannerMock>
      <ClaudeChatMock />
    </BannerMock>
  </BannerRoot>
);
